import api from './api';
import { ActiveTimer, TimeLog } from '../types';

interface StartTimerData {
  taskId: string;
  description?: string;
}

class TimeTrackingService {
  async getActiveTimer(): Promise<ActiveTimer> {
    const response = await api.get('/time-tracking/timer');
    return response.data;
  }

  async startTimer(data: StartTimerData): Promise<ActiveTimer> {
    const response = await api.post('/time-tracking/timer/start', data);
    return response.data;
  }

  async stopTimer(): Promise<TimeLog> {
    const response = await api.post('/time-tracking/timer/stop');
    return response.data;
  }

  async getTimeLogs(startDate?: Date, endDate?: Date): Promise<TimeLog[]> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const response = await api.get(`/time-tracking/time-logs?${params.toString()}`);
    return response.data;
  }

  async getTimesheet(date?: Date): Promise<any> {
    const params = new URLSearchParams();
    if (date) params.append('date', date.toISOString());

    const response = await api.get(`/time-tracking/timesheet?${params.toString()}`);
    return response.data;
  }

  async getTimeSummary(startDate?: Date, endDate?: Date): Promise<any[]> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const response = await api.get(`/time-tracking/summary?${params.toString()}`);
    return response.data;
  }

  async updateTimeLog(id: string, data: {
    description?: string;
    duration?: number;
    loggedAt?: Date;
    workType?: string;
    isBillable?: boolean;
  }): Promise<TimeLog> {
    const response = await api.put(`/time-tracking/time-logs/${id}`, data);
    return response.data;
  }

  async deleteTimeLog(id: string): Promise<void> {
    await api.delete(`/time-tracking/time-logs/${id}`);
  }
}

export const timeTrackingService = new TimeTrackingService();